module.exports = __webpack_public_path__ + "img/bx09-4.2fcf4f90.jpg";